import { render, staticRenderFns } from "./collapsibleStageCard.vue?vue&type=template&id=345bd651&"
import script from "./collapsibleStageCard.vue?vue&type=script&lang=js&"
export * from "./collapsibleStageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports